import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { IntegrationSyncStatus } from "../../../types";
import { managementActions } from "../../action-creators";
import { INTEGRATION_STATUS } from "app/pages/sales-intelligence/pages/management/constants/constants";

export const getHubspotStatusThunk =
    (hasLoading = true) =>
    async (
        dispatch: ThunkDispatchCommon,
        _getState: ThunkGetState,
        deps: ThunkDependencies,
    ): Promise<IntegrationSyncStatus> => {
        if (!salesSettingsHelper.isCrmIntegrationsEnabled()) {
            return INTEGRATION_STATUS.NotIntegrated;
        }

        try {
            dispatch(managementActions.hubspot.getHubspotStatusAsync.request(hasLoading));

            const response = await deps.si.api.management.getHubspotStatus();

            dispatch(managementActions.hubspot.getHubspotStatusAsync.success(response));

            return response.crmConnectionStatus.syncStatus;
        } catch (error) {
            dispatch(managementActions.hubspot.getHubspotStatusAsync.failure(error));

            return INTEGRATION_STATUS.NotIntegrated;
        }
    };
